<template>
    <v-container fluid>
        <v-row>
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="6"
                lg="10"
                md="8"
                sm="6"
            >
                <h3>Email Templates</h3>
            </v-col>
            <v-col 
                cols="6"
                lg="2"
                md="4"
                sm="6"
                class="text-right"
            >
                <v-btn 
                    color="primary" 
                    @click="newTemplate"
                >
                    New Template
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-form @submit.prevent="getRegisters">
                    <v-text-field
                        v-model="filter.fastSearch"
                        label="Quick Search"
                        prepend-inner-icon="mdi mdi-magnify"
                        single-line
                        outlined
                        @click:prepend-inner="getRegisters"
                        dense
                    ></v-text-field>
                </v-form>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="filteredSearch"
                    :options.sync="options"
                    :loading="loading"
                    :items-per-page="10"
                    no-data-text="No Record Found"
                >
                    <template v-slot:item.template="{ item }">
                        {{ item.template }}
                    </template>

                    <template v-slot:item.action="{item}">
                        <ActionList 
                            :id="item.id" 
                            :link="'templateEmail'"
                            :showButtons="{
                                edit: true
                            }"  />
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
    import Helpers from '@/utilities/Helpers';
    import ActionList from "@/components/Layout/ActionList";

    export default ({

        components: {
            ActionList: ActionList
        },

        mixins: [Helpers],

        data: () => ({

            loading: false,

            filter: {
                fastSearch: ''
            },

            headers: [
                { text: "ID", value: "id", sortable: true, size: "5%" },
                { text: "Template", value: "templateDescription", sortable: true },
                { text: "Subject", value: "subject", sortable: true },
                { text: "Actions", value: "action", sortable: false, align: "center" }
            ],

            options: { rowsPerPage: 10, page: 1 },

            listTemplateEmails: []
        }),

        computed: {

            filteredSearch: function() {
                return this.listTemplateEmails.filter((item) => {
                    const filter = this.filter.fastSearch.toLowerCase();
                    const template = (item.template || '').toString().toLowerCase().match(filter);
                    const subject = (item.subject || '').toLowerCase().match(filter);
                    const id = item.id.toString().match(filter);

                    if(template != null) return template;
                    if(subject != null) return subject;
                    return id;
                });
            }
        },

        methods: {
            async getRegisters() {
                this.listTemplateEmails = await this.$store.dispatch("templateEmailModule/List");
            },

            newTemplate() {
                this.$router.push({ name: 'templateEmail', params: { id: 0 } });
            },
        },

        created() {
            this.getRegisters();
        }
    })
</script>